export const selectTermsOfService = state => state.termsOfService.terms
export const selectTermsOfServiceErrorMessage = state =>
  state.termsOfService.errorMessage
export const selectTermsOfServiceState = state => state.termsOfService.state
export const selectTermsAcceptedAt = state =>
  state.account.currentUser.termsOfServiceAcceptedAt
